import { FormInput, InfoAlert, Text } from '@/components';
import { WalletTokenInterface, YieldBearingAssetInterface } from '@/interfaces';
import {
  formatNumberToAmountInTokenCurrencyString,
  formatNumberToAmountInUsdString,
} from '@/utils/formatUtils';
import {
  convertTokenAmountToUsd,
  replaceTokensInString,
} from '@/utils/functionalUtils';
import { YIELD_BEARING_ASSET_ACTIONS_CARD } from '@/utils/strings';
import { FC, useMemo } from 'react';
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
interface Props {
  yieldBearingAsset: YieldBearingAssetInterface;
  token?: WalletTokenInterface;
  amountInTokenCurrency: string;
  handleMaxClick: () => void;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  clearErrors: UseFormClearErrors<any>;
  errors: FieldErrors<any>;
}
const YieldBearingAssetInvestmentAmountInTokenCurrencyAndUsdInputs: FC<
  Props
> = ({
  yieldBearingAsset,
  token,
  amountInTokenCurrency,
  handleMaxClick,
  register,
  setValue,
  clearErrors,
  errors,
}) => {
  const usdSubtitle = useMemo(() => {
    if (!token?.priceInUsd) return 'USD';
    const tokenAmount = parseFloat(amountInTokenCurrency || '0');
    const usdValue = convertTokenAmountToUsd(tokenAmount, token);
    return `${formatNumberToAmountInTokenCurrencyString(
      tokenAmount,
      token.symbol || '',
    )} (${formatNumberToAmountInUsdString(usdValue)})`;
  }, [amountInTokenCurrency, token]);
  const replacements = useMemo(() => {
    const { ticker, name } = yieldBearingAsset;
    return {
      yield_bearing_asset_ticker: ticker,
      yield_bearing_asset_name: name,
      selected_asset_name: token?.name || '',
      selected_asset_ticker: token?.symbol || '',
    };
  }, [yieldBearingAsset, token]);
  return (
    <FormInput
      name="amount"
      type="number"
      label={
        YIELD_BEARING_ASSET_ACTIONS_CARD.SCREENS.DEPOSIT_FORM.AMOUNT_FIELD.LABEL
      }
      subtitle={usdSubtitle}
      defaultValue={amountInTokenCurrency}
      register={register}
      errors={errors}
      clearErrors={clearErrors}
      suffix={
        <Text
          value="Max"
          color="accent"
          className="font-medium cursor-pointer"
          onClick={handleMaxClick}
        />
      }
      tooltip={
        <InfoAlert
          title={replaceTokensInString(
            YIELD_BEARING_ASSET_ACTIONS_CARD.SCREENS.DEPOSIT_FORM.AMOUNT_FIELD
              .HELP_TITLE,
            replacements,
          )}
          description={replaceTokensInString(
            YIELD_BEARING_ASSET_ACTIONS_CARD.SCREENS.DEPOSIT_FORM.AMOUNT_FIELD
              .HELP_DESCRIPTION,
            replacements,
          )}
          intent="transparent"
        />
      }
      tooltipIsFullBleed
      showPercentageDial
      maxAmount={token?.balance}
    />
  );
};
export default YieldBearingAssetInvestmentAmountInTokenCurrencyAndUsdInputs;
